'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

class NativeAppService {
  postToApp(key, data) {
    if (typeof window.postToApp === "function") {
      window.postToApp(key, data);
    }
  }
  postLogout() {
    this.postToApp("logout", "");
  }
  postSystemLogout() {
    this.postToApp("logout", "systemLogout");
  }
  trackEventToAdjust(key, data) {
    if (typeof window.trackEventToAdjust === "function") {
      window.trackEventToAdjust(key, data);
    }
  }
  trackFirstDeposit(revenue, currency) {
    this.trackDeposit(revenue, currency, "first_deposit");
  }
  trackDeposit(revenue, currency, key = "deposit") {
    this.trackEventToAdjust(key, {
      revenue,
      currency
    });
  }
}
const nativeAppService = new NativeAppService();

exports.NativeAppService = NativeAppService;
exports.nativeAppService = nativeAppService;
